import { FormHelperText } from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { Dayjs } from 'dayjs';
import { forwardRef, isValidElement } from 'react';

import { WidgetsCommonProps } from '../widget.interface';
import {
  Container,
  Divider,
  InputTextLabel,
  PickerContainer,
} from './DateRangeWidget.styled';

export const DateRangeWidget = forwardRef((props: WidgetsCommonProps, ref) => {
  const onChange = (startDate: Dayjs | null, endDate: Dayjs | null) => {
    props.onChange([
      startDate?.set('hour', 0).set('minute', 0).set('second', 0),
      endDate?.set('hour', 23).set('minute', 59).set('second', 59),
    ]);
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Container ref={ref}>
        <PickerContainer>
          <InputTextLabel
            {...(isValidElement(props?.labels?.[0]) && { component: 'span' })}>
            {props?.labels?.[0]}
          </InputTextLabel>

          <DatePicker
            disabled={props.disabled}
            value={props?.values?.[0] ?? null}
            minDate={props.options?.startDateMin}
            maxDate={props.options?.startDateMax}
            disableFuture={props.options?.disableFuture}
            shouldDisableDate={(date: Dayjs) =>
              props.options?.isStartDateDisabled?.(date) ?? false
            }
            onChange={(value) => {
              onChange(value as Dayjs, props?.values?.[1] ?? null);
            }}
            slotProps={{
              textField: {
                error: Boolean(props.hasErrors?.[0]),
              },
              popper: {
                placement: props.options?.popperPlacement,
              },
            }}
          />
        </PickerContainer>

        {props.options?.showDivider && <Divider />}

        <PickerContainer>
          <InputTextLabel
            {...(isValidElement(props?.labels?.[1]) && { component: 'span' })}>
            {props?.labels?.[1]}
          </InputTextLabel>
          <DatePicker
            disabled={props.disabled}
            value={props?.values?.[1] ?? null}
            minDate={props.options?.endDateMin}
            maxDate={props.options?.endDateMax}
            disableFuture={props.options?.disableFuture}
            shouldDisableDate={(date: Dayjs) =>
              props.options?.isEndDateDisabled?.(date) ?? false
            }
            onChange={(value) => {
              onChange(props?.values?.[0] ?? null, value);
            }}
            slotProps={{
              textField: {
                error: Boolean(props.hasErrors?.[1]),
              },
              popper: {
                placement: props.options?.popperPlacement,
              },
              field: {
                readOnly: props?.readOnly,
              },
            }}
          />
        </PickerContainer>
      </Container>

      <FormHelperText error>{props.error}</FormHelperText>
    </LocalizationProvider>
  );
});
